import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { Series } from '@jwp/ott-common/types/series';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';
import type { ApiError } from '@jwp/ott-common/src/utils/api';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useSeries = (
  seriesId: string | undefined,
): {
  data: Series | undefined;
  error: ApiError | null;
  isLoading: boolean;
} => {
  const contentApiService = getModule(ContentApiService);

  // Try to get new series flow data
  const { data, isLoading, error }: UseQueryResult<Series, ApiError> = useQuery({
    queryKey: ['series', seriesId],
    queryFn: async () => {
      const config = useConfigStore.getState().config;

      return contentApiService.getSeries({ id: seriesId || '', config });
    },
    enabled: !!seriesId,
    // Don't retry when we got a not found error from either series or media item request (prevent unneeded requests)
    // Both errors mean that old series flow should be used
    retry: (failureCount, error: ApiError) => error.code !== 404 && failureCount < 2,
  });

  return { data, isLoading, error };
};
